import { appActions } from '@app';
import { createAsyncSelectors } from '@lib/selectors';
import { noop } from '@lib/utility';
import { securityActions } from '@sonar-software/sonar-security';
import { useAction } from '../useAction';
import { useSonarSelector } from '@hooks/useSonarSelector';
import { useCallback, useEffect, useRef } from 'react';
const selectors = createAsyncSelectors((state) => state.security.switchOrganization.post);
export function useSwitchOrganization() {
    const handlerRef = useRef(noop);
    const softResetApp = useAction(appActions.softResetApplication);
    const requestAction = useAction(securityActions.requestPostSecuritySwitchOrganization);
    const resetAction = useAction(securityActions.resetPostSecuritySwitchOrganization);
    const isSuccessful = useSonarSelector(selectors.isReceived);
    useEffect(() => {
        if (isSuccessful) {
            resetAction();
            handlerRef.current();
            softResetApp();
        }
    }, [isSuccessful, resetAction, softResetApp]);
    return useCallback((request, handler) => {
        handlerRef.current = handler || noop;
        requestAction(request);
    }, [requestAction]);
}
